import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { CalendarModule } from 'angular-calendar';

import 'hammerjs';
import {MatButtonModule, MatIconModule, MatSliderModule, MatCardModule, MatTooltipModule, MatDialogModule, MatDatepickerModule, MatNativeDateModule, MatMenuModule} from '@angular/material';

import {AppRoutingModule} from './app-routing.module';

import {AppComponent} from './app.component';
import {CalenderComponent} from './calender.component';
import { CalendarHeaderComponent } from './calender-header.component';
import {ProjectsComponent} from './projects/projects.component';
import {ProjectDialog} from './projects/projects.component';
import { ProjectDetailComponent} from './projects/project-detail.component';


@NgModule({
  declarations: [
    AppComponent,
    CalenderComponent,
    CalendarHeaderComponent,
    ProjectsComponent,
    ProjectDetailComponent,
    ProjectDialog
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    MatButtonModule,MatIconModule,MatCardModule,MatSliderModule,MatTooltipModule,MatDialogModule,MatDatepickerModule, MatNativeDateModule, MatMenuModule,
    CommonModule,
    CalendarModule.forRoot()
  ],
  providers: [],
  entryComponents: [ProjectDialog],
  bootstrap: [AppComponent],
  exports: [CalendarHeaderComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Library/WebServer/Documents/task-manager/src/app/app.module.ts